import { cn } from '../../../../utils'
import styles from './Input.module.css'

function Input(props: React.ComponentPropsWithRef<'input'>) {
  return <input {...props} className={cn(styles.input, props.className)} />
}

export default Input
